export default __webpack_public_path__ + "static/media/wineshelves.2822f031.png";